export default __webpack_public_path__ + "static/media/e3.78ea1b3f.jpg";